import { Box, Typography } from "@mui/material";
import React from "react";
import { updateFilter } from "store/slices/tableSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { CloseIcon } from "../components/Icons";
import { getAppliedFilterCount, matchDate } from "./helpers";

interface Props {
  name: string;
}

interface FilterItemProps {
  label: string;
  onDelete: () => void;
  keyProp?: string | number;
}

const FilterItem: React.FC<FilterItemProps> = ({
  label,
  onDelete,
  keyProp,
}) => {
  return (
    <Box
      key={keyProp}
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: 8,
        gap: "4px",
        p: "6px 8px",
        bgcolor: "var(--grey-50)",
      }}
    >
      <Typography fontSize={13} fontWeight={400} color="var(--black)">
        {label}
      </Typography>
      <CloseIcon cursor="pointer" onClick={onDelete} />
    </Box>
  );
};

export const TableFiltering: React.FC<Props> = (props) => {
  const { name } = props;

  const dispatch = useAppDispatch();

  const customFilter = useAppSelector(
    (state) => state?.table?.commonFilter[name]?.customFilter || {},
  );

  const appliedFilterCount = getAppliedFilterCount(customFilter);

  // const handleDeleteFilter = (type: string, value: any) => {
  //   const updatedCustomFilter = {
  //     ...commonFilter[name]?.customFilter,
  //   };

  //   switch (type) {
  //     case "start_date":
  //     case "end_date":
  //     case "financialYear":
  //       delete updatedCustomFilter.start_date;
  //       delete updatedCustomFilter.end_date;
  //       delete updatedCustomFilter.financialYear;
  //       break;

  //     case "date":
  //       delete updatedCustomFilter.date;
  //       break;

  //     case "portfolioFilterName":
  //       updatedCustomFilter.portfolioFilterName =
  //         updatedCustomFilter.portfolioFilterName.filter(
  //           (item: any) => item.value !== value,
  //         );
  //       updatedCustomFilter.portfolio = updatedCustomFilter.portfolio.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "type":
  //       updatedCustomFilter.type = updatedCustomFilter.type.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "format":
  //       updatedCustomFilter.format = updatedCustomFilter.format.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "source":
  //       updatedCustomFilter.source = updatedCustomFilter.source.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "company":
  //       updatedCustomFilter.company = updatedCustomFilter.company.filter(
  //         (item: any) => item.value !== value,
  //       );
  //       updatedCustomFilter.gcode = updatedCustomFilter.gcode.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "employeeName":
  //       updatedCustomFilter.employeeName =
  //         updatedCustomFilter.employeeName.filter(
  //           (item: any) => item.value !== value,
  //         );
  //       updatedCustomFilter.employee = updatedCustomFilter.employee.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "clientName":
  //       updatedCustomFilter.clientName = updatedCustomFilter.clientName.filter(
  //         (item: any) => item.value !== value,
  //       );
  //       updatedCustomFilter.client = updatedCustomFilter.client.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "groupName":
  //       updatedCustomFilter.groupName = updatedCustomFilter.groupName.filter(
  //         (item: any) => item.value !== value,
  //       );
  //       updatedCustomFilter.group = updatedCustomFilter.group.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "feePlanName":
  //       updatedCustomFilter.feePlanName =
  //         updatedCustomFilter.feePlanName.filter(
  //           (item: any) => item.value !== value,
  //         );
  //       updatedCustomFilter.feePlan = updatedCustomFilter.feePlan.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     case "partnerName":
  //       updatedCustomFilter.partnerName =
  //         updatedCustomFilter.partnerName.filter(
  //           (item: any) => item.value !== value,
  //         );
  //       updatedCustomFilter.partner = updatedCustomFilter.partner.filter(
  //         (item: any) => item !== value,
  //       );
  //       break;

  //     default:
  //       break;
  //   }

  //   dispatch(
  //     FILTER({
  //       ...commonFilter,
  //       [name]: {
  //         ...commonFilter[name],
  //         customFilter: updatedCustomFilter,
  //       },
  //     }),
  //   );
  // };

  const handleDeleteFilter = (type: string, value?: any) => {
    const updated = { ...customFilter };

    switch (type) {
      case "start_date":
      case "end_date":
      case "financialYear":
        delete updated.start_date;
        delete updated.end_date;
        delete updated.financialYear;
        break;
      case "date":
        delete updated.date;
        break;
      case "portfolioFilterName":
        updated.portfolioFilterName = updated.portfolioFilterName?.filter(
          (i: { value: number }) => i.value !== value,
        );
        updated.portfolio = updated.portfolio?.filter(
          (i: number) => i !== value,
        );
        break;
      case "company":
        updated.company = updated.company?.filter(
          (i: { value: string }) => i.value !== value,
        );
        updated.gcode = updated.gcode?.filter((i: string) => i !== value);
        break;
      case "employeeName":
        updated.employeeName = updated.employeeName?.filter(
          (i: { value: number }) => i.value !== value,
        );
        updated.employee = updated.employee?.filter((i: number) => i !== value);
        break;
      case "clientName":
        updated.clientName = updated.clientName?.filter(
          (i: { value: number }) => i.value !== value,
        );
        updated.client = updated.client?.filter((i: number) => i !== value);
        break;
      case "groupName":
        updated.groupName = updated.groupName?.filter(
          (i: { value: number }) => i.value !== value,
        );
        updated.group = updated.group?.filter((i: number) => i !== value);
        break;
      case "feePlanName":
        updated.feePlanName = updated.feePlanName?.filter(
          (i: { value: number }) => i.value !== value,
        );
        updated.feePlan = updated.feePlan?.filter((i: number) => i !== value);
        break;
      case "partnerName":
        updated.partnerName = updated.partnerName?.filter(
          (i: { value: number }) => i.value !== value,
        );
        updated.partner = updated.partner?.filter((i: number) => i !== value);
        break;
      case "type":
      case "format":
      case "source":
        updated[type] = updated[type]?.filter((i: string) => i !== value);
        break;
      default:
        break;
    }

    dispatch(updateFilter({ name, filter: { customFilter: updated } }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        alignItems: "center",
      }}
    >
      {appliedFilterCount !== 0 && (
        <Typography
          fontSize={12}
          fontWeight={500}
          color="var(--grey-500)"
          display={"flex"}
          alignItems={"center"}
          gap={0.5}
        >
          Applied Filters
          <Typography fontSize={12} fontWeight={600} color="var(--grey-700)">
            ({appliedFilterCount})
          </Typography>
          :
        </Typography>
      )}

      {/* Date */}
      {customFilter.date && (
        <FilterItem
          label={matchDate(customFilter.date)}
          onDelete={() => handleDeleteFilter("date", customFilter.date)}
        />
      )}

      {/* Start & End Date */}
      {customFilter.start_date && customFilter.end_date && (
        <FilterItem
          label={`${matchDate(customFilter.start_date)} - ${matchDate(customFilter.end_date)}`}
          onDelete={() => {
            handleDeleteFilter("start_date");
            handleDeleteFilter("end_date");
            handleDeleteFilter("financialYear");
          }}
        />
      )}

      {/* Generic array-based filters */}
      {[
        { key: "company", dualKey: "gcode" },
        { key: "employeeName", dualKey: "employee" },
        { key: "clientName", dualKey: "client" },
        { key: "groupName", dualKey: "group" },
        { key: "feePlanName", dualKey: "feePlan" },
        { key: "partnerName", dualKey: "partner" },
        { key: "portfolioFilterName", dualKey: "portfolio" },
      ].map(
        ({ key }) =>
          Array.isArray(customFilter?.[key]) &&
          customFilter[key].map((item: any, idx: number) => (
            <FilterItem
              key={`${key}-${item?.value ?? item}-${idx}`}
              label={item?.name ?? item}
              onDelete={() => handleDeleteFilter(key, item?.value ?? item)}
            />
          )),
      )}

      {/* format / source / type string arrays */}
      {["format", "source", "type"].map(
        (type) =>
          Array.isArray(customFilter?.[type]) &&
          customFilter[type].map((item: string, idx: number) => (
            <FilterItem
              key={`${type}-${item}-${idx}`}
              label={item.replaceAll("_", " ").toUpperCase()}
              onDelete={() => handleDeleteFilter(type, item)}
            />
          )),
      )}
    </div>
  );
};

export const importManagerFormats = [
  { name: "Gridkey CSV", value: "GRIDKEY_CSV" },
  { name: "Cash Entries", value: "GRIDKEY_CASH_CSV" },
];

export const importManagerSource = [
  { name: "Auto Contract Note", value: "Auto Contract Note" },
  { name: "Manual Import", value: "Manual Upload" },
];

export const transactionTypeIncomeExpense = [
  { name: "Expense", value: "expense" },
  { name: "Income", value: "income" },
];

export const transactionTypeCashEntry = [
  { name: "Deposit", value: "deposit" },
  { name: "Withdraw", value: "withdraw" },
  { name: "Fee Collected", value: "fees_collected" },
];

export const expensesType = [
  { name: "INTEREST", value: "interest" },
  { name: "DP CHARGES", value: "dp_charges" },
  { name: "AMC CHARGES", value: "amc_charges" },
  { name: "BROKERAGE", value: "brokerage" },
  { name: "OTHER CHARGES", value: "total_charges" },
  { name: "MISC EXP", value: "misc_exp" },
  { name: "LATE PAYMENT CHARGES", value: "late_payment_charges" },
];

export const incomeType = [
  { name: "DIVIDEND", value: "dividend" },
  { name: "INTEREST", value: "interest" },
  { name: "MISC INCOME ", value: "misc_income" },
];

export const tradeBookTransactionType = [
  { name: "Buy", value: "buy" },
  { name: "Sell", value: "sell" },
  { name: "IPO", value: "ipo" },
  { name: "BUY BACK", value: "buy_back" },
  { name: "RIGHT ISSUE", value: "right_issue" },
  { name: "PART PAYMENT", value: "partly_paid" },
];

export const positionTransactionType = [
  { name: "Buy", value: "buy" },
  { name: "Sell", value: "sell" },
];

export const mutualFundsType = [
  { name: "Purchase", value: "PURCHASE" },
  { name: "SIP Purchase", value: "SIP_PURCHASE" },
  { name: "Switch In", value: "SWITCH_IN" },
  { name: "Transfer In", value: "TRANSFER_IN" },
  { name: "STP In", value: "STP_IN" },
  { name: "Redemption", value: "REDEMPTION" },
  { name: "Switch Out", value: "SWITCH_OUT" },
  { name: "Transfer Out", value: "TRANSFER_OUT" },
  { name: "STP Out", value: "STP_OUT" },
  { name: "SWP", value: "SWP" },
  { name: "Dividend", value: "DIVIDEND" },
];

export const reportType = [
  {
    name: "Portfolio Performance Report",
    value: "Portfolio Performance Report",
  },
  { name: "Xirr Report", value: "Xirr Report" },
  {
    name: "Portfolio Summary Detailed Report",
    value: "Portfolio Summary Detailed Report",
  },
  { name: "Historical Valuation Report", value: "Historical Valuation Report" },
  { name: "Capital Gain Summary Report", value: "Capital Gain Summary Report" },
  {
    name: "Capital Gain Detailed Report",
    value: "Capital Gain Detailed Report",
  },
  {
    name: "Unrealized Capital Gain Summary Report",
    value: "Unrealized Capital Gain Summary Report",
  },
  {
    name: "Unrealized Capital Gain Detailed Report",
    value: "Unrealized Capital Gain Detailed Report",
  },
  { name: "Transaction Report", value: "Transaction Report" },
  { name: "Holding Period Report", value: "Holding Period Report" },
  { name: "Income Report", value: "Income Report" },
  { name: "Stock Register Report", value: "Stock Register Report" },
  { name: "Stock Wise Holdings Report", value: "Stock Wise Holdings Report" },
  { name: "Custom Report", value: "Custom Report" },
  { name: "Income Expense Report", value: "Income Expense Report" },
  { name: "AUM Growth Report", value: "AUM Growth Report" },
  { name: "Performance Report", value: "Performance Report" },
  { name: "Expense Report", value: "Expense Report" },
];

export const reportFormat = [
  { name: "PDF", value: "PDF" },
  { name: "EXCEL", value: "EXCEL" },
];

export const reportScheduleType = [
  { name: "Weekly", value: "Weekly" },
  { name: "Monthly", value: "Monthly" },
  { name: "Quarterly", value: "Quarterly" },
  { name: "Yearly", value: "Yearly" },
];

export const LEDGER_TRANSACTION_TYPE = [
  ...tradeBookTransactionType,
  { name: "Income", value: "INCOME" },
  { name: "Expense", value: "EXPENSE" },
];

export const totalOrdersType = [
  { name: "Allocation", value: "allocation" },
  { name: "Rebalance", value: "rebalance" },
  { name: "Exit", value: "exit" },
];

export const portfolioOption = (portfolios: any, form: any) => {
  return portfolios?.filter(
    (data: any) =>
      !form
        .getValues("portfolio")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

export const portfolioGroupOption = (portfolioGroupList: any, form: any) => {
  return portfolioGroupList?.filter(
    (data: any) =>
      !form
        .getValues("group")
        ?.map((dataItem: any) => dataItem)
        .includes(data?.value),
  );
};

export const companiesOption = (companies: any, form: any) => {
  return companies?.filter(
    (data: any) =>
      !form
        .getValues("gcode")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

export const clientOption = (clientList: any, form: any) => {
  return clientList?.filter(
    (data: any) =>
      !form
        .getValues("client")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

export const employeeOption = (employeeList: any, form: any) => {
  return employeeList?.filter(
    (data: any) =>
      !form
        .getValues("employee")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

export const feePlanOption = (feePlanList: any, form: any) => {
  return feePlanList?.filter(
    (data: any) =>
      !form
        .getValues("feePlan")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

export const partnerOption = (partnerList: any, form: any) => {
  return partnerList?.filter(
    (data: any) =>
      !form
        .getValues("partner")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

export const reportTypeOption = (reportList: any, form: any) => {
  return reportList?.filter(
    (data: any) =>
      !form
        .getValues("type")
        ?.map((dataItem: any) => dataItem)
        .includes(data.value),
  );
};

// Include Filter
export const includePortfolio = [
  "portfolio_list",
  "holding_details",
  "bank_statement_list",
  "trade_book_list",
  "private_equity_list",
  "available_cash_list",
  "fee_calculation",
  "proforma_invoice",
  "invoice_list",
  "mutual_funds_list",
  "income_expense_list",
  "bank_ledger_list",
  "FD_list",
  "FD_payout_list",
  "aif_list",
  "client_upload_proof",
  "subscribed_history",
  "partner_client_list",
  "portfolio_mapping",
  "commission_manager",
  "partner_commission",
  "revenue_mandate",
  "position_list",
  "automation",
];

export const includePortfolioGroup = ["portfolio_group_list"];

export const includeCompany = [
  "trade_book_list",
  "private_equity_list",
  "portfolio_trade_book_list",
  "mutual_funds_list",
  "portfolio_mutual_funds",
  "portfolio_interest",
  "holding_summary_list",
  "insights_list",
  "portfolio_holding_list",
  "portfolio_group_holding_list",
  "client_holding_list",
  "family_holding_list",
  "branch_holding_list",
  "employee_holding_list",
  "portfolio_holdings_table",
  "anchor_transaction",
  "portfolio_private_equity_list",
  "portfolio_FD_list",
  "FD_list",
  "FD_payout_list",
  "portfolio_FD_Payout_list",
  "portfolio_aif_list",
  "aif_list",
  "position_list",
  "portfolio_position_list",
];

export const includeDateRange = [
  "fee_calculation",
  "portfolio_calculation",
  "proforma_invoice",
  "portfolio_proforma",
  "invoice_list",
  "portfolio_invoice",
  "trade_book_list",
  "private_equity_list",
  "wallet_full_history",
  "portfolio_trade_book_list",
  "bank_ledger_list",
  "mutual_funds_list",
  "portfolio_mutual_funds",
  "bank_statement_list",
  "income_expense_list",
  "portfolio_income_expense",
  "portfolio_bank_ledger_list",
  "portfolio_cash_entry",
  "portfolio_private_equity_list",
  "portfolio_FD_list",
  "FD_list",
  "portfolio_FD_Payout_list",
  "FD_payout_list",
  "portfolio_aif_list",
  "aif_list",
  "position_list",
  "portfolio_position_list",
  "total_orders",
  "modelPortfolioOrderManager",
];

export const includeDate = [
  "import_manager_list",
  "custom_broker",
  "recon_manager_list",
  "portfolio_import_manager_list",
  "portfolio_interest",
  "report_list",
  "report_scheduler_list",
];

export const includeType = [
  "bank_statement_list",
  "income_expense_list",
  "portfolio_income_expense",
  "portfolio_cash_entry",
];

export const includeTransactionType = [
  "trade_book_list",
  "private_equity_list",
  "portfolio_trade_book_list",
  "mutual_funds_list",
  "portfolio_mutual_funds",
  "bank_ledger_list",
  "portfolio_bank_ledger_list",
  "portfolio_private_equity_list",
  "portfolio_aif_list",
  "aif_list",
];

export const includeClient = [
  "client_list",
  // "proforma_invoice",
  // "portfolio_proforma",
  // "invoice_list",
  // "portfolio_invoice",
  "fee_collection",
];

export const includeEmployee = [
  "branch_admin_list",
  "import_manager_list",
  "recon_manager_list",
  "portfolio_import_manager_list",
];

export const includeFormat = ["import_manager_list", "report_list"];

export const includeFeePlan = [
  "fee_calculation",
  "portfolio_calculation",
  "coupon",
  "portfolio_mapping",
  "automation",
];

export const includePartner = [
  "partner_list",
  "commission_manager",
  "portfolio_commission",
];

export const includeReportType = ["report_list", "report_scheduler_list"];

export const includePositionTransactionType = [
  "position_list",
  "portfolio_position_list",
  "total_orders",
  "modelPortfolioOrderManager",
];
